import React from "react";
import HeroImg from "../../../assets/images/Hero-Section.png";

export default function HeroSection() {
  return (
    <section id="home" className="relative scroll-mt-[90px] w-full py-16 bg-white pt-[120px]">
      <div className="px-4 sm:px-6 lg:px-[60px] relative z-20">

        {/* FLEX ROW */}
        <div className="flex flex-col items-start justify-between gap-8 lg:flex lg:gap-10">

          {/* LEFT TEXT */}
          <div className="flex flex-col z-[30] max-w-[650px] lg:pt-10 w-full">
            <h1 className="text-[32px] sm:text-[42px] lg:text-[56px] xl:text-[60px] font-bold leading-tight sm:leading-tight lg:leading-tight text-gray-900">
              Laundry, Hassle-Free We Connect You to the Best Local Experts.  
            </h1>

            <p className="text-gray-600 text-[15px] sm:text-[17px] lg:text-[18px] mt-4 sm:mt-6 max-w-[450px]">
Book your pick-up, sit back, and let our trusted partners take care of your clothes. No more searching — get quality service at your doorstep, always at clear prices.  
            </p>
          </div>

          {/* RIGHT IMAGE */}
          <div className="relative flex justify-center w-[98%] lg:justify-end">
            <img
              src={HeroImg}
              alt="Hero"
              className="
                w-auto
                max-w-[280px]
                max-sm:max-w-[500px] max-sm:ml-[260px] max-sm:pt-10 max-sm:mb-[-60px]
                sm:max-w-[400px]
                max-md:max-w-[800px] max-md:mr-[330px] max-md:mt-[-100px]
                md:max-w-[800px]    md:-mt-40
                lg:max-w-[1000px] lg:-mt-[399px] lg:-mr-[80px]
                xl:max-w-[1489px]
                2xl:max-w-[1489px]
                -mt-[20px] sm:-mt-[50px] xl:-mt-[550px] xl:-mb-[310px] 2xl:mr-20
                drop-shadow-sm
                object-contain
                select-none
              "
            />
          </div>

        </div>

      </div>

      {/* BOOK NOW BACKGROUND TEXT */}
      <div className="absolute inset-0 flex items-center justify-center overflow-hidden pointer-events-none">
        <span className="
          text-[60px] 
          max-sm:text-[75px] max-sm:mt-[340px]
          sm:text-[140px]
          max-md:text-[80px] max-md:mt-[220px]
          md:text-[120px] md:mt-[150px]
          lg:text-[160px] lg:mt-20
          xl:text-[226px] xl:-mb-[310px]
          2xl:text-[226px]
          leading-[0.8]
          tracking-[-0.02em]
          sm:tracking-[-0.03em]
          lg:tracking-[-0.04em]
          font-extrabold
            text-transparent
              bg-clip-text
              bg-gradient-to-b from-[#6a0dad] to-white
              opacity-70
              select-none
              whitespace-nowrap
          transform
          scale-95
          sm:scale-100
          -mt-10
          sm:-mt-0
        ">
          BOOK NOW
        </span>
      </div>

    </section>
  );
}